import { fetchAuthenticatedUser, getAuthService } from '@edx/frontend-platform/auth';

/**
 * Refreshes the user's authentication token and updates the authenticated user data
 * @returns {Promise<boolean>} Returns true if successful, false if there was an error
 */
export async function refreshUserToken() {
  try {
    const authService = getAuthService();
    const jwtTokenService = authService.getJwtTokenService();
    await jwtTokenService.getJwtToken(true);
    await fetchAuthenticatedUser();
    return true;
  } catch (error) {
    console.error('Error refreshing user token:', error);
    throw error;
  }
} 